import React, { Component } from 'react';
import $ from 'jquery'



class CenikPraciASluzeb extends Component {
    componentDidMount(){


        function resetMenu(){
            $("#home a").removeClass("active");

            $("#sluzby-a-produkty-link").removeClass("active");
            $("#prodej-instalace-li").removeClass("active");
            $("#lokalni-li").removeClass("active");
            $("#outsourcing-li").removeClass("active");
            $("#audit-is-li").removeClass("active");
            $("#webhosting-li").removeClass("active");
            $("#webdesign-li").removeClass("active");
            $("#cenik-praci-li").removeClass("active");

            $("#o-firme-li a").removeClass("active");
            $("#reference-li a").removeClass("active");
            $("#kontakty-li a").removeClass("active");
            $("#podpora-li a").removeClass("active");
        }

        resetMenu();

        $("#cenik-praci-li").addClass("active");
        $("#basic-nav-dropdown").addClass("active");


    }
  render() {
    return (
<div>


        <div className="container content fade-in two" id="cenik">
            <h1>Ceník prací a služeb</h1>
                <div className="col-sm-12">
                            <table className="table">

                                <tbody>
                                <tr>
                                    <td> <h2>Práce (ceny za započatou hodinu práce nebo 1 PC)</h2></td>
                                    <td> <h2>Cena</h2></td>

                                </tr>
                                <tr>
                                    <td>úpravy nastavení aplikačních software a OS, odvirování počítače, profilaxe - vyčištění HW počítače,
                                        opravy hardware, technické práce na HW počítačových sítí</td>
                                    <td>od 800,- Kč</td>
                                </tr>
                                <tr>
                                    <td>běžné úpravy konfigurace síť. software (firewall, proxy, mail server, NAS QNAP/Synology, WinServer 2011/2016/2019)</td>
                                    <td>od 1000,- Kč</td>
                                </tr>
                                <br/> <br/>
                                <tr>
                                    <td><h2>Instalace software (ceny za započatou hodinu práce nebo PC či Server)</h2></td>
                                </tr>
                                <tr>
                                    <td>instalace systému Win10 (nové PC/NB dodané firmou RICOM Tech s.r.o.)</td>
                                    <td>od 2.500,- Kč</td>
                                </tr>
                                <tr>
                                    <td>instalace systému Win10 (nové PC/NB nedodané firmou RICOM Tech s.r.o.)</td>
                                    <td>od 3.000,- Kč</td>
                                </tr>
                                <tr>
                                    <td>instalace systému Win10 (kompletní přeinst. PC/NB vč. zálohy a vrácení dat)</td>
                                    <td>od 4.000,- Kč</td>
                                </tr>
                                <tr>
                                    <td>instalace systému NAS QNAP/Synology, WinServer2011/2016/2019</td>
                                    <td>od 5.000,- Kč (dle rozsahu prací)</td>
                                </tr>
                                <tr>
                                    <td>instalace aplikačních SW na serverech NAS QNAP/Synology, WinServer2011/2016/2019</td>
                                    <td>od 1.000,- Kč</td>
                                </tr>
                                <tr>
                                    <td>základní instalace Linux serveru (firewall, 5 mail účtů, antivir,  antispam, webmail, proxy server)</td>
                                    <td>od 5.000,- Kč</td>
                                </tr>
                                <tr>
                                    <td>instalace a konfigurace web serveru Apache pro jednu doménu</td>
                                    <td>od 3.000,- Kč</td>
                                </tr>
                                <tr>
                                    <td>instalace sdílení na Linux serveru pro 5 uživatelů (samba)</td>
                                    <td>od 2.000,- Kč</td>
                                </tr>
                                <tr>
                                    <td>ostatní práce na linux serverech ( přídání dalších uživatelů, instalace print nebo fax serveru )</td>
                                    <td>od 1.000,- Kč</td>
                                </tr>
                                <br/> <br/>


                                <tr>
                                    <td><h2>Speciální práce (ceny za započatou hodinu práce)</h2></td>
                                </tr>
                                <tr>
                                    <td>propojování sítí WAN, LAN, úpravy WIFI</td>
                                    <td>od 1.000,- Kč</td>
                                </tr>
                                <tr>
                                    <td>speciální konfigurační síťové práce firewalle, routing, proxy, VPN</td>
                                    <td>od 1.250,- Kč</td>
                                </tr>
                                <tr>
                                    <td>školení softwarových produktů</td>
                                    <td>smluvní cena dle dohody</td>
                                </tr>
                                <tr>
                                    <td>návrh počítačových sítí - poradenství</td>
                                    <td>smluvní cena dle dohody</td>
                                </tr><br/><br/>

                                <tr>
                                    <td><h2>Smluvní servis – paušál</h2></td>
                                </tr>
                                <tr>
                                    <td>měsíční cena za 1 PC/NB v síti</td>
                                    <td>od 800,- Kč</td>
                                </tr>
                                <tr>
                                    <td>měsíční cena za 1 NAS QNAP/Synology / WinServer 2011/2016/2019 v síti (dle složitosti a OS)</td>
                                    <td>od 4.000,- Kč</td>
                                </tr><br/><br/>

                                <tr>
                                    <td><h2>Záchrana a zálohování dat</h2></td>
                                </tr>
                                <tr>
                                    <td>záchrana/obnova dat z HDD, SSD, Flash</td>
                                    <td>smluvní cena dle dohody</td>
                                </tr>
                                <tr>
                                    <td>záloha dat jiným způsobem u zákazníka a následné zálohování v sídle firmy zákazníka</td>
                                    <td>smluvní cena dle dohody</td>
                                </tr><br/><br/>

                                <tr>
                                    <td><h2>Webhosting (roční poplatek)</h2></td>
                                </tr>
                                <tr>
                                    <td>Standard (www prostor do 100Mb - do 5 email. účtů do celkové velikosti 10 GB)</td>
                                    <td>od 2.500,- Kč</td>
                                </tr>
                                <tr>
                                    <td>Profi (www prostor do 250Mb - do 15 email. účtů do celkové velikosti 30 GB)</td>
                                    <td>od 4.000,- Kč</td>
                                </tr>
                                <tr>
                                    <td>Exclusiv  (www prostor neomezeně – počet účtů a  jejich velikost neomezeně)</td>
                                    <td>smluvní cena</td>
                                </tr>
                                <tr>
                                    <td>Založení/prodloužení domén cz,com,eu,net aj.</td>
                                    <td>od 200,- Kč / doménu</td>
                                </tr><br/><br/>

                                <tr>
                                    <td><b>cestovné a ostatní náklady v rámci služby * Praha a okolí do 5 km</b> </td>
                                    <td>od 500,- Kč (mimo Prahu 10 Kč / km nebo dle dohody)</td>
                                </tr><br/><br/>
                                <tr>
                                    <td><b>expresní příplatek - oprava ihned nebo do 24 hodin (sobota, neděle, svátky)</b> </td>
                                    <td><b>+ 100% nebo dle dohody</b></td>
                                </tr><br/><br/>
                                <tr>
                                    <td><b>uvedené ceny jsou smluvní a jsou uvedeny bez DPH 21% - platnost cen od 1. června 2022</b> </td>

                                </tr>
                                </tbody>
                            </table>
                </div>


        </div>


</div>
    );
  }
}

export default CenikPraciASluzeb;



// WEBPACK FOOTER //
// ./src/sluzby-a-produkty/CenikPraciASluzeb.js